import { render } from "./signReceipt.vue?vue&type=template&id=8cc7da7a&scoped=true"
import script from "./signReceipt.vue?vue&type=script&lang=js"
export * from "./signReceipt.vue?vue&type=script&lang=js"

import "./signReceipt.vue?vue&type=style&index=0&id=8cc7da7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc7da7a"]])

export default __exports__